import React, { useState, useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../redux/hooks';
import { Box } from '@mui/material';
import { useTheme } from '../themeContext';
import { isMobile } from 'react-device-detect';

// -- Components 

import Notification from '../components/general/notification/Notification';
import Container from '../components/groupSelection/Container';
import Page from '../components/general/containers/Page';

const GroupSelection: React.FC = () => {

  const colors = useAppSelector(state => state.theme.colors);

  // -- 

  return (

    <Page>

      <Container/>

    </Page>
  );
};

export default GroupSelection;